// eslint-disable-next-line no-shadow
enum EFilterType {
    ANY = 'Any',
    ALL = 'All',
}

export default EFilterType
